import type { ApiISODateTimeString } from '#/api/types/ApiTypedDate';
import { BodyMicro } from '#/components/Text/BodyMicro';
import { useI18n } from '#/i18n/hooks/useI18n';
import { ListingStatusLabel } from '#/modules/listing/components/ListingStatusLabel/ListingStatusLabel';
import { shorterDate } from '#/utils/date';

type Props = {
  status: 'ACTIVE' | 'INACTIVE';
  created: ApiISODateTimeString;
};

export function SearchHitApplicationStatus({ status, created }: Props) {
  const { i18n, locale } = useI18n();

  return (
    <>
      <ListingStatusLabel listingStatus={status} asTag forceSolid />

      <BodyMicro>
        {i18n('Applied %(date)s', {
          date: shorterDate({ date: created, locale }),
        })}
      </BodyMicro>
    </>
  );
}
